import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import FormDetails from 'LIBRARY/Components/LibraryDetails/LibraryDetails';
import NotFound from 'LIBRARY/CommonResources/NotFound/NotFound';
import LibraryDetails from 'LIBRARY/Components/LibraryDetails/LibraryDetails';

export class RoutesSetup extends Component {
    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route path="/:instituteUrl/category/:categoryId" component={LibraryDetails} />
                        <Route path="/:instituteUrl" component={LibraryDetails} />
                        
                        <Route path="*" component={NotFound} />
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

export default RoutesSetup;
